<template>
  <div class="InspectItem">
    <p>外送检测项目</p>
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <!-- <p>
        <label>就诊日期：</label>
        <Select v-model="clinicTime" >
          <Option v-for="item in clinicTimeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </p> -->
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" placeholder="开始日期" v-model="startDate"></DatePicker>
         ——
        <DatePicker type="date" placeholder="结束日期·" v-model="endDate"></DatePicker>
      </p>
      <!-- <p>
        <label>收费门类：</label>
        <Select v-model="chargeCategory" >
          <Option v-for="item in chargeCategorys" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </p> -->
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
  </div>
</template>

<script>
import {
  accountList,noAccountList,settleAccount
} from "../../api/inspection";
export default {
  name: 'InspectItem',
  data () {
    return {
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      clinicTime:'',//就诊时间
      clinicTimeList:[],
      startDate:'',//开始日期
      endDate:'',//结束日期
      chargeCategory:'',//收费门类
      chargeCategorys:[],
      columns1:[
        {
          title: '患者',
          key: 'hospitalPatientName',
          align:'center'
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '诊断',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
            title: '就诊日期',
            key: 'chargeTime',
            align:'center',
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.chargeTime) 
              },
            })
          }
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:100,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-order'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'chargeDetail';
                      this.modelTitle = '已退费详情';
                      let id = params.row.id;
                      this.haveRefundDetail(id,params.row);
                    },
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-guanbi1'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.cancelRefund(id);
                    }
                  }
                }, '取消'),
            ]);
          }
        }
      ],
      data1:[]
    }
  },
  mounted(){
    this.loadList();
  },
  methods:{
    //加载页面
    loadList(){
      this.search();
    },
    search(){
      let _this = this;
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.InspectItem{
   overflow: scroll;
  height: 100%;
}
.InspectItem .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}
.InspectItem .toolBar>p{
  padding: 5px 0;
  margin-right: 10px;
}
.InspectItem .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/views/inspection/InspectItem.vue